<template>
  <div id="document-tab">
    <table>
      <thead>
        <tr>
          <th>{{ $t('DOC_TYPE') }}</th>
          <th>{{ $t('UPLOADER') }}</th>
          <th>{{ $t('CREATED_DATE') }}</th>
          <th>{{ $t('ACTIONS') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="doc.id" v-for="doc in docs">
          <td>{{ $t(getDocTypeKey(doc.typeId)) }}</td>
          <td>{{ doc.createdBy.firstName }} {{ doc.createdBy.lastName }}</td>
          <td>{{ moment(doc.createdAt).format('DD/MM/YYYY | HH:mm') }}</td>
          <td>
            <font-awesome-icon class="icon" @click="view(doc.path)" :icon="faEye" />
            <font-awesome-icon class="icon" @click="deleteDocument(doc.id)" :icon="faTrash" />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btns float-right">
      <primary-button class="button" @click="navigateReprint" :icon="faPrint" independence :text="$t('VIEW_CONTRACT')" />
      <primary-button class="button" @click="clickUpload" :icon="faCloudUploadAlt" blue :text="$t('UPLOAD')" />
    </div>

    <document-upload v-model="on" />
    <confirm-modal />
  </div>
</template>

<script>
import moment from 'moment';
import { faPrint, faCloudUploadAlt, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import PrimaryButton from '@/components/PrimaryButton';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


import { ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import ConfirmModal from '@/components/ConfirmModal';
import DocumentUpload from './DocumentUpload';

import ContractDetailServices from '../../ContractDetailServices';

const { useState, useActions } = createNamespacedHelpers('contractDetail');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useActions: useConfirmActions } = createNamespacedHelpers('confirm');
const { useActions: useModalActions } = createNamespacedHelpers('modal');
const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'DocumentTab',
  components: {
    PrimaryButton,
    FontAwesomeIcon,
    DocumentUpload,
    ConfirmModal,
  },
  setup(_, { root }) {
    const { contractDocTypes } = useAppState(['contractDocTypes']);
    const { docs, targetingContract: contract } = useState(['docs', 'targetingContract']);
    const { getContractDocs } = useActions(['getContractDocs']);
    const { info: flashInfo } = useFlashActions(['info']);
    const { setTitleModal, setOnConfirm } = useConfirmActions(['setTitleModal', 'setOnConfirm']);
    const { toggleConfirmModal } = useModalActions(['toggleConfirmModal']);

    const on = ref(false);

    const getDocTypeKey = (typeId) => {
      const docType = contractDocTypes.value.find((t) => t.id === typeId);
      return docType?.key || '';
    };

    const clickUpload = () => { on.value = !on.value; };

    const view = (link) => {
      window.open(link, '_blank');
    };

    const navigateReprint = () => {
      root.$router.push({ name: 'contract-review', params: { id: contract.value.publicId } });
    };

    const deleteDocument = async (id) => {
      setTitleModal(root.$t('CONFIRM_DELETE_PAPER'));

      const onConfirm = async () => {
        await ContractDetailServices.deleteDocument(id);
        flashInfo(root.$t('SUCCESSFULLY_DELETED_DOCUMENT'));
        getContractDocs();
      };

      setOnConfirm(onConfirm);
      toggleConfirmModal();
    };

    watch(contract, (newDetail) => {
      if (newDetail && newDetail.id) {
        getContractDocs();
      }
    }, {
      immediate: true
    });

    return {
      faPrint,
      faCloudUploadAlt,
      faEye,
      faTrash,
      docs,
      on,
      clickUpload,
      view,
      navigateReprint,
      deleteDocument,
      moment,
      getDocTypeKey
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#document-tab {
  table {
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;
    background-color: $ghostWhite;

    thead {
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;

      tr {

        th {
          background-color: $brightMaroon;
          color: $white;
          padding: 15px 10px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;
          font-size: 14px;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;

          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        background-color: $babyPowder;
        transition: all .2s ease-in-out;

        &:hover {
          background-color: $ghostWhite;
        }

        td {
          padding: 15px 5px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }

          .icon {
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .btns {
    margin: 20px 0;
    padding-right: 15px;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
